import { EnvironmentType } from '../app/shared/constants';
import { config } from './config.shared';

const production = {
  production: true,
  environmentType: EnvironmentType.Prod,
};

export const environment = Object.freeze(Object.assign(production, config));
